<header class="bg-bhbody">
  <div class="container-fluid ps-lg-5 pe-lg-5 nav-top-notification m-0 pb-0">
    <nav>
      <ul class="d-flex flex-row justify-content-between w-100">
        <li class="mx-auto mx-md-0">
          <!-- Logo -->
          <a class="navbar-brand" href="#">
            <img class="" src="{{this.environment.assets.logo_alternative}}" alt="Logo alternativo" i18n-alt>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>